import GlobalStyles from "./GlobalStyles";
import DefaultTheme from "../Themes/DefaultTheme";

const Colors = {
  lightGray: DefaultTheme.palette.light.contrastText,
  lightBlue: DefaultTheme.palette.info.lightAlternative,
};

const BoxBasic = {
  cursor: "pointer",
  height: "30px",
  transition: "background-color 200ms, color 200ms",
};

const miniBoxBasic = {
  paddingTop: "5px",
  height: "26px",
  transition: "background-color 200ms, color 200ms",
};


const BigCalendarStyles = (Theme) => ({
  ...GlobalStyles(Theme),
  avatar: {
    width: Theme.spacing(12),
    height: Theme.spacing(12),
    margin: "auto",
    display: "inline-block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  timeBox: {
    ...BoxBasic,
    borderRight: "1px solid " + Colors.lightGray,
    textAlign: "center",
    fontSize: "14px",
    paddingTop: "19px",
  },
  miniTimeBox: {
    ...miniBoxBasic,
    borderRight: "1px solid " + Colors.lightGray,
    textAlign: "center",
    fontSize: "12px",
    paddingTop: "5px",
    width: 50,
    "@media screen and (max-width: 960px) and (min-width: 750px)": {
      width: 80,
    },
    "@media screen and (max-width: 750px) and (min-width: 630px)": {
      width: 60,
    },
    "@media screen and (max-width: 600px) and (min-width: 500px)": {
      width: 65,
    },
  },
  notSelected: {
    backgroundColor: DefaultTheme.palette.success.contrastText,
  },
  availableBlock: {
    backgroundColor: Theme.palette.secondary.main,
  },
  classBlock: {
    backgroundColor: Theme.palette.primary.main,
  },
  redHoverBlock: {
    backgroundColor: DefaultTheme.palette.primary.light,
  },
  hoverBlock: {
    opacity: "0.5",
  },
  selectedFromCustomer: {
    backgroundColor: Theme.palette.primary.main,
  },
  individualBookedByYou: {
    backgroundImage:
      "linear-gradient(45deg, #71904d 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #71904d 50%, #71904d 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  individualBookedBlock: {
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  selectableIndividualBlock: {
    backgroundColor: Theme.palette.secondary.main,
  },
  selectableGroupBlock: {
    backgroundColor: Theme.palette.info.main,
  },
  fullGroupBlock: {
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  groupBookedByYou: {
    backgroundImage:
      "linear-gradient(45deg, #2582ac 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #2582ac 50%, #2582ac 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  sampleSelectedBlockFromCustomer: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor:  Theme.palette.primary.main,
  },
  sampleSelectedBlockFromCustomerMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor:  Theme.palette.primary.main,
  },
  sellerSampleAvailableBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
  },
  sellerSampleAvailableBlockInSeller: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    margin: "4px"
  },
  sellerSampleAvailableBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
  },
  sellerSampleSelectedBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.secondary.main,
  },
  sellerSampleSelectedBlockInSeller: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.secondary.main,
    margin: "4px"
  },
  sellerSampleSelectedBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.secondary.main,
    margin: "4px",
  },
  sellerClassBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.primary.main,
  },
  sellerClassBlockInLessonModal: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.primary.main,
    margin: "4px",
  },
  customerSampleFreeBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
  },
  customerSampleFreeBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
  },
  customerSampleCanSelectIndividualBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.secondary.main,
  },
  customerSampleCanSelectIndividualBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.secondary.main,
  },
  customerSampleBookedFromYouLessonIndividualBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #71904d 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #71904d 50%, #71904d 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleBookedFromYouLessonIndividualBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #71904d 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #71904d 50%, #71904d 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleBookedLessonIndividualBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleBookedLessonIndividualBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleCanSelectClassBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.info.main,
  },
  customerSampleCanSelectClassBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    backgroundColor: Theme.palette.info.main,
  },
  customerSampleBookedFromYouLessonClassBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #2582ac 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #2582ac 50%, #2582ac 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleBookedFromYouLessonClassBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #2582ac 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #2582ac 50%, #2582ac 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleFullClassBlock: {
    width: "16px",
    height: "16px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  customerSampleFullClassBlockMini: {
    width: "10px",
    height: "10px",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "8px",
    marginBottom: "4px",
    //backgroundColor: "#EEEEEE",
    backgroundImage:
      "linear-gradient(45deg, #c7c7c7 37.50%, #2e2e2e 37.50%, #2e2e2e 50%, #c7c7c7 50%, #c7c7c7 87.50%, #2e2e2e 87.50%, #2e2e2e 100%)",
    backgroundSize: "5.66px 5.66px",
  },
  individualCell_ForBookedView: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontSize: "13px",
    paddingLeft: "5px",
    lineHeight: 1,
    backgroundColor: Theme.palette.secondary.main,
  },
  groupCell_ForBookedView: {
    backgroundColor: Theme.palette.info.main,
  },
  groupCell_ForBookedViewInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontSize: "11px",
    paddingLeft: "5px",
    lineHeight: 1,
    color: DefaultTheme.palette.success.contrastText,
  },
  dayBox: {
    ...BoxBasic,
    borderBottom: "1px solid " + Colors.lightGray,
    borderRight: "1px solid " + Colors.lightGray,
  },
  dayBoxMerged: {
    ...BoxBasic,
    borderRight: "1px solid " + Colors.lightGray,
  },
  dayBoxRight: {
    ...BoxBasic,
    borderBottom: "1px solid " + Colors.lightGray,
  },
  dayBoxRightMerged: {
    ...BoxBasic,
  },
  dayBoxBottom: {
    ...BoxBasic,
    borderRight: "1px solid " + Colors.lightGray,
  },
  dayBoxBottomRight: {
    ...BoxBasic,
  },
  miniDayBox: {
    ...miniBoxBasic,
    borderBottom: "1px solid " + Colors.lightGray,
    borderRight: "1px solid " + Colors.lightGray,
  },
  miniDayBoxRight: {
    ...miniBoxBasic,
    borderBottom: "1px solid " + Colors.lightGray,
  },
  miniDayBoxBottom: {
    ...miniBoxBasic,
    borderRight: "1px solid " + Colors.lightGray,
  },
  miniDayBoxBottomRight: {
    ...miniBoxBasic,
  },
  headerDay: {
    padding: "5px",
    transition: "background-color 200ms, color 200ms",
  },
  miniHeaderDay: {
    paddingTop: "5px",
    paddingLeft: "14px",
    paddingRight: "14px",
    transition: "background-color 200ms, color 200ms",
    fontSize: "11px",
    marginLeft: "-5px",
    marginRight: "-5px",
    "@media screen and (max-width: 1200px) and (min-width: 960px)": {
      fontSize: "8px",
    },
  },
  miniHeaderDayFirst: {
    paddingTop: "5px",
    paddingLeft: "14px",
    paddingRight: "14px",
    transition: "background-color 200ms, color 200ms",
    fontSize: "12px",
    width: "53px",
    "@media screen and (max-width: 1200px) and (min-width: 960px)": {
      width: "50px",
    },
  },

  timeGrdiContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    border: "1px solid " + Colors.lightGray,
    borderRadius: "6px",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    borderBottom: "1px solid " + Colors.lightGray,
    borderTop: "1px solid " + Colors.lightGray,
  },
  miniContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
  },
  cardContainer: {
    /*[Theme.breakpoints.down('xs')]:
    {
    },
    [Theme.breakpoints.up('sm')]: {
      width: "500px",
    },
    [Theme.breakpoints.up('md')]: {
      width: "800px",
    }*/
  },
  cardContent: {
    textAlign: "left",
    padding: "0px 15px 15px 15px",
    maxHeight: "600px",
    overflow: "auto",
  },
  miniCardContent: {
    textAlign: "left",
    padding: "0px 15px 0px 15px !important",
    maxHeight: "600px",
    overflow: "auto",
  },
  cardContentForSeller: {
    textAlign: "left",
    padding: "0px 15px 15px 15px",
    maxHeight: "200px",
    overflow: "auto",
  },
  cardContentForSellerOnModal: {
    textAlign: "left",
    padding: "0px 15px 15px 15px",
    overflow: "auto",
  },
  calendarNote: {
    fontSize: "12px",
    color: DefaultTheme.palette.default.contrastAlternative,
    [Theme.breakpoints.only("xs")]: {
      fontSize: "10px",
    }
  },
  dateString : {
    flex: 1,
    paddingBottom: "19px",
    [Theme.breakpoints.only("xs")]: {
      paddingBottom: "unset",
    }
  },
  browserAlert: {
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 13,
    "@media screen and (max-width: 600px) ": {
      fontSize: 11,
    },
  }
});

export default BigCalendarStyles;
